module.exports = __webpack_public_path__ + "static/media/Spider.df04e184.glb";